import * as React from 'react';

type VideoTimelineProps = {
  duration: number;
  currentTime: number;
  startTime: number | null;
  endTime: number | null;
};

export default function VideoTimeline({ duration, currentTime, startTime, endTime }: VideoTimelineProps) {
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);

    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const getPercentage = (time: number) => (time / duration) * 100;

  return (
    <div className="absolute bottom-0.5 left-2 right-2 p-2 overflow-visible z-[1000] pointer-events-none">
      <div className="relative h-2 bg-white/30 rounded mb-2 overflow-visible">
        {/* Current time indicator */}
        <div
          className="absolute -top-1 w-4 h-4 bg-white rounded-full transform -translate-x-1/2 z-[1001] border-2 shadow-lg"
          style={{ left: `${getPercentage(currentTime)}%` }}
        />

        {/* Start time indicator */}
        {startTime !== null && (
          <div
            className="absolute -top-1 w-1 h-4 bg-yellow-400 rounded-sm transform -translate-x-1/2 z-[1000]"
            style={{ left: `${getPercentage(startTime)}%` }}
            title={`Start: ${formatTime(startTime)}`}
          />
        )}

        {/* End time indicator */}
        {endTime !== null && (
          <div
            className="absolute -top-1 w-1 h-4 bg-yellow-400 rounded-sm transform -translate-x-1/2 z-[1000]"
            style={{ left: `${getPercentage(endTime)}%` }}
            title={`End: ${formatTime(endTime)}`}
          />
        )}

        {/* Highlighted section between start and end */}
        {startTime !== null && endTime !== null && (
          <div
            className="absolute top-0 h-2 bg-emerald-400 rounded z-[1]"
            style={{
              left: `${getPercentage(startTime)}%`,
              width: `${getPercentage(endTime - startTime)}%`,
            }}
          />
        )}
      </div>
    </div>
  );
}
